import { Masks } from "@hooks/functions/Masks/Masks";
import React, { useState } from "react";

import { FiEye, FiEyeOff } from "react-icons/fi";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  labelColor?: string;
  showLabel?: boolean;
  animated?: boolean;
  placeholder?: string;
  mask?: "phone" | "cpf" | "cnpj" | "cep" | "data" | "milhar";
  register?: any;
  errorMessage?: string;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => void;
}

const masks = new Masks();
export function Input({
  label,
  labelColor,
  showLabel,
  placeholder,
  className,
  animated,
  register,
  mask,
  type,
  errorMessage,
  onChange,
  ...rest
}: IProps) {
  const [showPassword, setShowPassword] = useState(false);

  const maskObj = {
    phone: masks.phone,
    cpf: masks.cpf,
    cnpj: masks.cnpj,
    cep: masks.postalCode,
    data: masks.date,
    milhar: masks.formatMilhar,
  };

  return (
    <>
      {animated ? (
        <div className={`form-floating ${className} input-${type}`}>
          <input
            className={`form-control ${errorMessage ? "is-invalid" : ""}`}
            placeholder={placeholder}
            type={
              type === "password" && showPassword ? "text" : (type ?? "text")
            }
            {...register}
            {...rest}
            onChange={(e) => {
              if (mask && maskObj[mask]) {
                if (mask === "milhar") {
                  const numericValue =
                    parseFloat(e.target.value.replace(/\D/g, "")) || 0;
                  e.target.value = masks.formatMilhar(numericValue);
                } else {
                  e.target.value = maskObj[mask](e.target.value);
                }
              }
              if (onChange) onChange(e);
            }}
          />
          {errorMessage && (
            <div className="invalid-feedback">{errorMessage}</div>
          )}

          <label>{label}</label>
          {type === "password" && (
            <button
              className="border-0"
              onClick={() => {
                setShowPassword(!showPassword);
              }}
            >
              {showPassword ? <FiEye /> : <FiEyeOff />}
            </button>
          )}
        </div>
      ) : (
        <div>
          {label && (
            <label
              className={`form-label ${labelColor ? `text-${labelColor}` : ``}`}
            >
              {label}
            </label>
          )}

          <div className={`${className} input-${type}`}>
            <input
              className={`form-control ${errorMessage ? "is-invalid" : ""}`}
              placeholder={placeholder}
              type={
                type === "password" && showPassword ? "text" : (type ?? "text")
              }
              {...register}
              {...rest}
              onChange={(e) => {
                if (mask && maskObj[mask]) {
                  if (mask === "milhar") {
                    const numericValue =
                      parseFloat(e.target.value.replace(/\D/g, "")) || 0;
                    e.target.value = masks.formatMilhar(numericValue);
                  } else {
                    e.target.value = maskObj[mask](e.target.value);
                  }
                }
                if (onChange) onChange(e);
              }}
            />

            {errorMessage && (
              <div className="invalid-feedback">{errorMessage}</div>
            )}

            {type === "password" && (
              <button
                className="border-0"
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              >
                {showPassword ? <FiEye /> : <FiEyeOff />}
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
}
